/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mcp_Gemini_Web_RequirementsInputs */

const en_mcp_gemini_web_requirements = /** @type {(inputs: Mcp_Gemini_Web_RequirementsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Custom apps need a personal Google account, and you must be 18 or older and in the US.`)
};

const es_mcp_gemini_web_requirements = /** @type {(inputs: Mcp_Gemini_Web_RequirementsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Las apps personalizadas requieren una cuenta personal de Google, tener 18 años o más y estar en EE. UU.`)
};

/**
* | output |
* | --- |
* | "Custom apps need a personal Google account, and you must be 18 or older and in the US." |
*
* @param {Mcp_Gemini_Web_RequirementsInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mcp_gemini_web_requirements = /** @type {((inputs?: Mcp_Gemini_Web_RequirementsInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mcp_Gemini_Web_RequirementsInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mcp_gemini_web_requirements(inputs)
	return en_mcp_gemini_web_requirements(inputs)
});